import { render, staticRenderFns } from "./FormularioCredito.vue?vue&type=template&id=68781d25"
import script from "./FormularioCredito.vue?vue&type=script&lang=js"
export * from "./FormularioCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports